export const personalInfo = {
  name: "Faizan",
  title: "Software Engineer",
  tagline: "Crafting elegant solutions through code",
  description:
    "Specialized in web development with a passion for creating seamless user experiences.",
  currentWork: {
    position: "Software Engineer",
    company: "WSP",
    description:
      "Currently working as a Software Engineer at WSP, where I focus on building scalable web applications and innovative solutions for complex problems.",
  },
  stats: [
    { number: "4+", label: "Years of Experience" },
    { number: "14+", label: "Projects Completed" },
    { number: "2", label: "Countries Worked In" },
  ],
  location: "St John's, Canada",
  email: "faizansaleem790@gmail.com",
  socialLinks: {
    github: "https://github.com/faizansaleem-dev",
    linkedin: "https://linkedin.com/in/faizansaleem95",
    whatsapp: "https://wa.me/923334429789",
  },
  // Add more sections as needed for other components
};

export const siteConfig = {
  // Theme configuration
  theme: {
    primary: "blue",
    secondary: "gray",
    accent: "white",
  },
  // Navigation configuration
  navigation: [
    { name: "Home", path: "/" },
    { name: "Projects", path: "/projects" },
    { name: "Experience", path: "/experience" },
    { name: "Skills", path: "/skills" },
    { name: "Education", path: "/education" },
    { name: "Contact", path: "/contact" },
  ],
};

// Experience section data
export const experiences = [
  // Add your experiences here
  {
    company: "WSP",
    position: "Software Engineer",
    period: "2022 - Present",
    description: "Description of role and responsibilities",
    technologies: ["React", "Node.js", "AWS"],
  },
];

export const skillsData = {
  categories: [
    {
      title: "Frontend Development",
      icon: "💻",
      skills: [
        "React",
        "Next.js",
        "TypeScript",
        "JavaScript",
        "HTML/CSS",
        "Tailwind CSS",
      ],
    },
    {
      title: "Backend Development",
      icon: "⚡",
      skills: [
        "Node.js",
        "NestJS",
        "MongoDB",
        "PostgreSQL",
        "RESTful APIs",
        "GraphQL",
      ],
    },
    {
      title: "Cloud & DevOps",
      icon: "☁️",
      skills: [
        "AWS",
        "EC2",
        "Amplify",
        "Elastic Beanstalk",
        "Code Pipeline",
        "Lambda",
      ],
    },
    {
      title: "Tools & Version Control",
      icon: "🛠️",
      skills: ["Git", "GitHub", "Code Commit", "Docker", "VS Code", "Postman"],
    },
  ],
};

export const educationData = {
  degrees: [
    {
      title: "Master of Science in Computer Science",
      institution: "Memorial University of Newfoundland",
      institutionUrl: "https://www.mun.ca/",
      period: "2022 - 2024",
      tags: ["AI", "Data Mining", "HCI", "Software Engineering"],
      coursework: [
        "Machine Learning",
        "Data Mining Techniques",
        "Advanced HCI",
        "Applied Algorithms",
        "Software Engineering",
        "ASIC Design",
      ],
      projects: [
        {
          title: "Financial RAG System",
          points: [
            "Designed and implemented a retrieval-augmented generation (RAG) system for financial document question-answering.",
            "Utilized LlamaIndex, LlamaParse, GPT-4o-mini, Gemini embeddings, and DeepEval for end-to-end benchmarking.",
            "Engineered intelligent document chunking and context retrieval workflows.",
            "Integrated multiple LLM-embedding combinations to generate accurate and grounded responses.",
            "Evaluated system performance using faithfulness and relevancy metrics to assess output quality.",
            "Demonstrated the effectiveness of RAG in enhancing domain-specific LLM applications.",
          ],
        },
      ],
    },
    {
      title: "BSc Computer Science",
      institution: "University of Management and Technology",
      institutionUrl: "https://umt.edu.pk",
      period: "2015 - 2019",
      coursework: [
        "Artificial Intelligence",
        "Machine Learning",
        "Software Engineering",
        "Digital Image Processing",
        "Web Technologies",
      ],
      projects: [
        {
          title: "Autonomous Car Cleaning Robot",
          description:
            "Led a team of three to develop an innovative autonomous car cleaning robot.",
          points: [
            "Integration of NodeMCU and Arduino for robot control",
            "Advanced sensor-based navigation system",
            "Custom-designed flexible robotic arm with high-pressure resistance",
            "Intelligent path planning algorithms for efficient cleaning",
          ],
        },
      ],
    },
  ],
};

export const experienceData = [
  {
    title: "Software Engineer",
    company: "WSP in Canada",
    companyUrl: "https://www.wsp.com",
    period: "2023 - Present",
    technologies: ["ReactJs", "AWS", "SQL", "Mobile Development"],
    points: [
      "Built an internal Message Centre application from an initial template to production, enabling project managers to broadcast critical announcements to clients and integrate them into the weather portal UI. Implemented the frontend with React and Material UI and the backend with Node.js and PostgreSQL, deploying via AWS Lambda (Serverless) and S3/CloudFront, and set up a shared development environment for the team.",
      "Modernized legacy jQuery/JavaScript views into React functional components, improving maintainability and user experience while keeping legacy flows working. Rebuilt interfaces that display time-series weather data (graphs and filterable tables) for different sites and client types, preserving functionality and making data exploration more intuitive.",
      "Led the migration of a legacy authentication system to AWS Cognito, participating in architecture design and risk analysis for a phased rollout. Implemented new .NET controllers and services to integrate Cognito, developed Lambda triggers for custom verification and approval flows, and authored a CloudFormation template to standardize multi-tenant Cognito user pools. Executed a staged release by gradually shifting load balancers and monitored logs and metrics to ensure users were not blocked.",
      "Developed a Python automation script to onboard approximately 700 users into the new SSO-enabled authentication system. The script ingests Excel data, validates and cleans malformed input, creates users in Cognito and required databases, sends welcome emails with login instructions, and verifies correct setup; later extended to support multiple clients, significantly reducing manual onboarding effort.",
      "Optimized SQL queries and stored procedures, including cross-database joins, used by controllers to power forecast and notification workflows. Proactively identified slow or error-prone queries, collaborated with operations to refine them, and analyzed data quality (flags, unit conversions, value correctness) to improve reliability of weather data for customers.",
      "Contributed to an internal microservice-based forecast production system, updating controllers in multiple services (job service, data service, product service) to generate new forecast report outputs for clients and deploying updated services using Docker, ensuring consistency across the pipeline.",
      "Designed and implemented new features for a mobile application, contributing to the enhancement of user engagement and functionality.",
    ],
  },
  {
    title: "Software Engineer",
    company: "Muasa Solutions",
    companyUrl: "https://muasasolutions.com/",
    period: "2021 - 2023",
    technologies: [
      "NodeJS",
      "ExpressJS",
      "NestJS",
      "GraphQL",
      "MongoDB",
      "PostgreSQL",
      "NextJs",
      "TypeScript",
    ],
    points: [
      "Designed and maintained backend services and API's (RESTful and GraphQL) using NodeJS frameworks, specifically ExpressJS and NestJS",
      "Evaluated migration of non-relational data to relational data and programmed a migration script to migrate data from MongoDB to Postgres Database",
      "Designed Test cases for APIs and Client-side utilizing Jest and Cypress to ensure robust code performance, compatibility and security",
      "Worked closely with the engineering manager to improve the scalability of an already developed system by 40%, remodeling the database design",
      "Built a client-side for an admin dashboard from scratch using NextJs and Typescript",
    ],
  },
  {
    title: "Full Stack Developer",
    company: "Brandpa",
    companyUrl: "https://brandpa.com",
    period: "2019 - 2021",
    technologies: ["ExpressJS", "ReactJS", "AWS", "Full Stack"],
    points: [
      "Oversaw and contributed to the development of two in-house products for the company",
      "Programmed and built backend services using ExpressJS and integrated those services on Client-side which was developed using ReactJS",
      "Maintained and deployed both products using AWS services",
    ],
  },
];
